export default __webpack_public_path__ + "static/media/palaute-darkblue.b3aee6ca.svg";